import React, { useEffect } from 'react';
import { ConnectionModel } from '../connection.model';
import PolicyActionsModal from './policy-actions-modal/policy-actions-modal';
import PolicySummaryModal from './ecm-inline-actions/policy-summary-modal';
import CancelSmartModal from '../../../shared/cancel-smart-modal/cancel-smart-modal';
import EditConnectionModal from './ecm-inline-actions/edit-connection-modal';
import EditStandardConnectionNameModal from './ecm-inline-actions/edit-standard-connection-name-modal';
import { ECMActionType } from 'src/utils/enums';

export interface ModalState {
    type?: 'policyActions' | 'policySummary' | 'cancelSmart' | 'editConnection' | 'editStandardName';
    actionType?: ECMActionType;
    connection?: ConnectionModel;
}

interface EcmModalsProps {
    modalState: ModalState;
    setModalState: (state: ModalState) => void;
}

const EcmModals: React.FC<EcmModalsProps> = ({
                                                 modalState,
                                                 setModalState
                                             }) => {
    const handleCloseModal = () => setModalState({...modalState, type: undefined});
    const [selectedConnectionMap, setSelectedConnectionMap] = React.useState<Map<number, ConnectionModel>>(new Map());

    useEffect(() => {
        if (modalState.connection?.id !== undefined) {
            setSelectedConnectionMap(new Map([[modalState.connection.id, modalState.connection]]));
        } else {
            setSelectedConnectionMap(new Map());
        }
    }, [modalState]);

    return (
        <>
            {modalState.connection && (
                <>
                    <PolicyActionsModal
                        visible={modalState.type === 'policyActions'}
                        onClose={handleCloseModal}
                        initialAction={modalState.actionType}
                        selectedConnections={selectedConnectionMap}
                    />
                    <PolicySummaryModal
                        connection={modalState.connection}
                        isOpen={modalState.type === 'policySummary'}
                        onClose={handleCloseModal}
                    />
                    <CancelSmartModal
                        visible={modalState.type === 'cancelSmart'}
                        onClose={handleCloseModal}
                        connectionId={modalState.connection.id}
                    />
                    <EditConnectionModal
                        visible={modalState.type === 'editConnection'}
                        onClose={handleCloseModal}
                        connection={modalState.connection}
                    />
                    <EditStandardConnectionNameModal
                        visible={modalState.type === 'editStandardName'}
                        onClose={handleCloseModal}
                        connection={modalState.connection}
                    />
                </>
            )}
        </>
    );
};

export default EcmModals;
